import React, { Component, Fragment } from 'react'
import { isEmpty } from 'lodash'
import { Helmet } from 'react-helmet'
import { translate } from 'react-i18next'
import parse from 'html-react-parser';
import Error from './Error'
import Layout from './Layout'
import RecursiveElement from './RecursiveElement'
import Spinner from './Spinner'
import A from "./A";
// import VCRow from "./VCRow";
// import VCColumn from "./VCColumn";

/*
 * TODO:
 * - sort, order
 * - display post date
 * - page.parent_id - what for can I use it?
 * - propTypes!
 */

class Post extends Component {

  constructor(props) {
    super(props)
    this.state = {
      entity: null,
      error: null,
      type: null
    }

    if (isEmpty(props.slugs.items) || (props.slugs.code !== null && props.slugs.code !== 200)) {
      props.findAllSlugs() // required
      // find will be dispatched on componentDidUpdate
    }
    else {
      const slug = props.slugs.items[props.match.params.slug]
      if (slug !== undefined && slug.getType() === 'post' && props.posts[slug.getTarget()] === undefined) {
        props.getPost(slug.getTarget(), true)
      } else if (slug !== undefined && slug.getType() === 'page' && props.pages[slug.getTarget()] === undefined) {
        props.getPage(slug.getTarget(), true)
      }
    }
  }

  // set new state based on received props
  static getDerivedStateFromProps(props, state) {
    if (props.slugs.code !== null && props.slugs.code !== 200)
      return { error: 'err.oops' }

    // FIXME: if is fetching?
    if (isEmpty(props.slugs.items))
      return null

    const slug = props.slugs.items[props.match.params.slug]
    if (slug === undefined)
      return { error: 'err.postNotExist' }

    const type = slug.getType()

    // FIXME: if is fetching?
    const entity = slug.getType() === 'post' ? props.posts[slug.getTarget()] : props.pages[slug.getTarget()]
    if (entity === undefined)
      return null

    if (entity.getCode() !== 200)
      return { error: 'err.loadingPost' }

    return { entity, error: null, type }
  }

  // get page if not in redux
  componentDidUpdate(prevProps, prevState, snapshot) {
    // new slugs received (async api request initiated in constructor has finished)
    if ((!isEmpty(this.props.slugs.items) && isEmpty(prevProps.slugs.items)) || this.props.match.params.slug !== prevProps.match.params.slug) {
      const slug = this.props.slugs.items[this.props.match.params.slug];
      if (slug !== undefined && this.props.posts[slug.getTarget()] === undefined) {
        if (slug.getType() === 'post') {
          this.props.getPost(slug.getTarget(), true)
        } else if (slug.getType() === 'page') {
          this.props.getPage(slug.getTarget(), true)
        }
      }
    }
    // FIXME if slugs.code === error || page.code === error then refresh?
  }

  wrapPostWithBackButton(child) {
    if (this.state.type !== "post")
      return child;
    return <div style={{position: 'relative'}}>
      <div style={{position: 'absolute', left: '-10vw'}}>
        <A style={{cursor: 'pointer'}} onClick={() => window.history.go(-1)}>
          {this.props.t("custom:back")}
        </A>
      </div>
      <p className='date' style={{fontWeight: 'bold', marginBottom: '0px', paddingTop: '2px'}}>{this.state.entity.getDate().slice(0, -9)}</p>
      {child}
    </div>
  }
  
  render() {
    if (this.state.error)
      return <Layout><Error>{this.props.t(this.state.error.keys || this.state.error, this.state.error.options)}</Error></Layout>;

    if (this.state.entity === null)
      return <Spinner>{this.props.t('msg.loadingPost')}</Spinner>;
  

    return <Layout contentClassName={this.state.type}
                   title={this.state.entity !== null ? this.state.entity.getTitle() : null}
                   mediaId={this.state.entity !== null ? this.state.entity.getMedia() : null}>
      <Fragment>
        <Helmet>
          <title>{this.state.entity.getTitle()}</title>
          {this.state.entity.getYoastMeta() &&
                this.state.entity.getYoastMeta().map((el, id) => parse(`<${el.name} key=${id} ${el.attribs.property ? `property="${el.attribs.property}"` : ``} ${el.attribs.name ? `${el.attribs.name ? `name` : ``}="${el.attribs.name ? el.attribs.name : ``}"` : ``} ${el.attribs.content ? `content="${el.attribs.property == `og:url` ? window.location.href : el.attribs.content}"` : ``} ${el.name == 'title' ? `>${el.children[0].data}</title>` : `/>`}`)) 
          }
        </Helmet>
        {this.wrapPostWithBackButton(<RecursiveElement element={this.state.entity.getDom()}/>)}
      </Fragment>
    </Layout>;
  }

}

export default translate()(Post)



// WEBPACK FOOTER //
// ./src/components/Post.js